import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdminAuthService } from '../services/admin-auth.service';

/**
 * Blocks /admin routes unless the server confirms admin access (authenticated admin, or dev DisableAuthentication).
 * Redirects to access-denied instead of loading admin UI.
 */
export const adminAccessGuard: CanActivateFn = () => {
  const router = inject(Router);
  const adminAuth = inject(AdminAuthService);

  if (!environment.adminEnabled) {
    const queryParams =
      environment.defaultSurveyTypeId != null
        ? { surveyTypeId: environment.defaultSurveyTypeId }
        : {};
    void router.navigate(['/intake/create'], { queryParams, replaceUrl: true });
    return false;
  }

  return adminAuth.ensureAdminAccess().pipe(
    map((allowed) => {
      if (!allowed) {
        void router.navigate(['/access-denied'], { replaceUrl: true });
        return false;
      }
      return true;
    }),
    catchError(() => {
      void router.navigate(['/access-denied'], { replaceUrl: true });
      return of(false);
    })
  );
};
